import { redirectToLogin } from 'src/utils';

export default () => (next) => (action) => {
  const { errorStatus } = action;

  if (errorStatus === 401) {
    return redirectToLogin();
  }

  return next(action);
};
